export class LineVariableCostExpenseModel {
  variableCostsPerDrivenKm: number = 0;
  tireExpense: number = 0;
  fuelExpense: number = 0;
  totalLineVariableCostExpense: number = 0;
}
